module.exports = __webpack_public_path__ + "img/hero_en.00b854b.jpg";